<div class="layout-footer">
    <img src="assets/images/connect_gen_logo.png" alt="Logo" height="50" class="mr-2"/>
</div>
    <p class="font-medium ml-2" style="text-align:center; margin-top:10px;">by Zilon</p>
